export class BaseContainerModel {

}
